import { DefectCodeDialog } from "./DefectCodeDialog";
import { FormikValues } from "formik";
import { Button } from "primereact/button";
import { useCallback, useState, MouseEvent, useMemo } from "react";
import { FormInputText } from "../Shared/FormInputText";
import { useAppSelector } from "../../hooks/storeHooks";
import { selectDefectCodes } from "../../store/selectors/defectSelectors";

type Props = {
    disabled: boolean;
    formik: FormikValues;
    category?: string;
    description?: string;
}

export const FormDefectCode = (props: Props) => {
    const { disabled, formik, category, description } = props;
    
    const [visible, setVisible] = useState(false);
    const defectCodes = useAppSelector(selectDefectCodes);

    const hasEnteredCode = useMemo(() => {
        const typeCode = formik.values.typeCode;
        return typeCode && typeCode.trim() !== "";
    }, [formik.values.typeCode]);

    const onClick = useCallback(async (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        const errors = await formik.validateForm();
        
        const hasDescriptionError = !!errors.description;
        
        if (!hasDescriptionError) {
            setVisible(true);
        } else {
            formik.setFieldTouched('description', true);
        }
    }, [formik])

    const onSubmit = useCallback(async (typeCode: string | null, codeAssignReason?: string | null, suggestedCodes?: string[]) => {
        formik.setFieldValue("typeCode", typeCode);
        if (codeAssignReason) {
            formik.setFieldValue("codeAssignReason", codeAssignReason);
        }
        if (suggestedCodes) {
            formik.setFieldValue("suggestedCodes", JSON.stringify(suggestedCodes));
        }
    }, [formik])

    const onHide = useCallback(() => {
        setVisible(false);
    }, []);

    return (
        <div className="flex justify-content-between">
            <div className="flex-1 mr-3">
                <FormInputText disabled={disabled} formik={formik} value="typeCode" label="Defect Code" data-cy="defect-code-input" uppercase/>
            </div>
            <div>
                <Button label="Assign Defect Code" onClick={onClick} disabled={disabled || (!category && !formik.values.description && !hasEnteredCode)} data-cy="assign-defect-code-button"/>
            </div>
            <DefectCodeDialog 
                onSubmit={onSubmit} 
                visible={visible} 
                onHide={onHide} 
                currentTypeCode={formik.values.typeCode}
                category={category}
                description={description}
                data-cy="defect-code-dialog"
            />
        </div>
    );
}